import React, { useRef } from 'react';
import './BestSellersSection.scss';
import { useCollection } from '../../../../firebase-files/hooks/useCollection';
import { useNavigate } from 'react-router-dom';

const BestSellersSection = () => {
  const { documents: products } = useCollection('products');
  const { documents: settings } = useCollection('settings');
  const navigate = useNavigate();

  const productRef = useRef(null);

  const currencyDoc = settings?.find(doc => doc.id === 'currency');
  const currencySymbol = currencyDoc?.symbol || '₹';

  const topSelling = products?.filter(product => product.topSellingProducts === true) || [];

  const handleShopClick = () => {
    navigate('/products-two?filter=top-selling');
  };

  const handleProductClick = (productId) => {
    if (productId) navigate(`/product-details-two/${productId}`);
  };

  const formatPrice = (value) => {
    return new Intl.NumberFormat('en-IN', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(value);
  };

  const scrollLeft = () => {
    if (productRef.current) {
      productRef.current.scrollBy({ left: -300, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    if (productRef.current) {
      productRef.current.scrollBy({ left: 300, behavior: 'smooth' });
    }
  };

  return (
    <section className="top-selling-section">
      <div className="best-sellers-wrapper">
        <div className="left-info">
          <h2>
            Bestselling Blooms
          </h2>
          <p>Discover our most loved bouquets.</p>
          <button onClick={handleShopClick}>Shop Bestselling Blooms</button>
        </div>

        <div className="products-wrapper">
          <button className="slick-arrow left-arrow" onClick={scrollLeft}>
            &#10094;
          </button>

          <div className="products" ref={productRef}>
            {topSelling.map((plant, index) => (
              <div
                className="product-card"
                key={plant.id || index}
                onClick={() => handleProductClick(plant.id)}
              >
                <div className="image-wrapper">
                  <img
                    src={
                      Array.isArray(plant.images)
                        ? plant.images[0] || '/fallback-image.jpg'
                        : plant.images || '/fallback-image.jpg'
                    }
                    alt={plant.name}
                  />
                  {plant.discount && <span className="discount">-{plant.discount}</span>}
                  {plant.tag && <span className="tag">{plant.tag}</span>}
                  {plant.tag && (
                    <div className="actions">
                      <button>🛒</button>
                      <button>🔍</button>
                    </div>
                  )}
                </div>
                <h3>{plant.name}</h3>
                <div className="price">
                  {plant.originalPrice && (
                    <span className="original">
                      {currencySymbol} {formatPrice(plant.originalPrice)}
                    </span>
                  )}
                  <span className="current">
                    {currencySymbol} {formatPrice(plant.price)}
                  </span>
                </div>
              </div>
            ))}
          </div>

          <button className="slick-arrow right-arrow" onClick={scrollRight}>
            &#10095;
          </button>
        </div>
      </div>
    </section>
  );
};

export default BestSellersSection;
